import React from "react";

import { ListItem, ListItemIcon, ListItemText } from "@mui/material";
import { makeStyles } from "tss-react/mui";

import { colors } from "@/theme/overrides/colors";

const useStyles = makeStyles()((theme) => ({
  listItem: {
    paddingTop: 20,
    paddingBottom: 20,
  },
  listItemSubItem: {
    paddingTop: 10,
    paddingBottom: 10,
    "& .MuiListItemText-primary": {
      fontSize: 14,
    },
  },
  listItemIcon: {
    color: colors.gray,
  },
  listItemText: {
    color: colors.dark,
  },
  listItemTextPrimary: {
    fontWeight: 600,
    fontSize: 16,
    lineHeight: 1,
    letterSpacing: -0.5,
  },
  chevron: {
    color: colors.dark,
    minWidth: 0,
  },
  activeLink: {
    color: theme.palette.primary.main,
    "& .MuiListItemIcon-root": {
      color: "inherit",
    },
    "& .MuiListItemText-root": {
      color: "inherit",
    },
  },
}));

interface ListItemLinkProps {
  href?: string;
  rel?: string;
  target?: string;
  icon?: React.ReactNode;
  text: string;
  subItem?: boolean;
  onHover?: () => void;
  onHoverEnd?: () => void;
}

const ListItemHref: React.FC<ListItemLinkProps> = ({
  href,
  rel,
  target,
  icon,
  text,
  subItem,
}) => {
  const { classes } = useStyles();

  return (
    <li>
      <ListItem
        className={`${classes.listItem} ${subItem && classes.listItemSubItem}`}
        component="a"
        href={href}
        rel={rel}
        target={target}
        button
      >
        {Boolean(icon) && (
          <ListItemIcon className={classes.listItemIcon}>{icon}</ListItemIcon>
        )}
        <ListItemText
          className={classes.listItemText}
          classes={{ primary: classes.listItemTextPrimary }}
          primary={text}
          inset={!icon}
        />
      </ListItem>
    </li>
  );
};

export default ListItemHref;
